module.exports = __webpack_public_path__ + "img/en-gov-mt_white.7d50bde6.png";